
//@deprecated use import { UserSessionService } from '../../services/user-session'
export { UserSessionService as IUserSession, UserSessionServiceProvider as UserSession } from '../services/user-session'
